<template>
<div>
  <!--    Breadcrumbs-->
  <breadcrumb style="margin-left: -15px">
    <breadcrumb-item>
      <a href="/surveys/view">Surveys</a>
    </breadcrumb-item>
    <breadcrumb-item>
      <span>{{ survey.name }}</span>
    </breadcrumb-item>
  </breadcrumb>
  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>

  <div class="row">
    <div class="col-12">
      <card>
        <div class="row mb-3">
          <div class="col">
            <div
              class="btn-group btn-group-toggle"
              :class="'float-left'"
              data-toggle="buttons"
            >
              <label
                v-for="(option, index) in categories"
                :key="index + 'j'"
                class="btn btn-sm btn-primary btn-simple"
                :class="{ active: option.active }"
                :id="index"
              >
                <input
                  type="radio"
                  @click="switchTab(index)"
                  name="options"
                  autocomplete="off"
                  :checked="option.active"
                />
                <span style="font-size: medium; font-weight: lighter"  class="d-none d-sm-block">{{ option.name }}</span>
                <span class="d-block d-sm-none">
                    <i :class="option.icon"></i>
                  </span>
              </label>
            </div>
          </div>
        </div>

        <div v-if="activeTabIndex === 0">
          <div class="mt-3" v-if="survey_questions.length <= 0 ">
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No surveys have been filled out yet.</h4>
            </div>
          </div>
<!--          Mobile-->
          <div class="d-block d-sm-none">
            <div v-if="survey_questions.length > 0" class="row table-content">
              <div class="col">
                <b-table hover :items="survey_questions"
                         :fields="['question']">
                  <template v-slot:cell(question)="row">
                    <div class="row">
                      <div class="col">
                        <span style="font-size: large">{{ row.item.question }}</span>
                        <i style="cursor: pointer" v-on:click="viewQuestionResponses(row.item)" class="tim-icons el-icon-top-right text-primary"></i>
                      </div>
                      <div class="col-4 text-right">
                        <badge class="ml-2" type="danger" v-if="!row.item.active">inactive</badge>
                        <badge class="ml-2">{{ row.item.type }}</badge>
                      </div>
                    </div>

                    <div v-if="row.item.type === 'Input'">Response count: {{ row.item.input_count }}</div>
                    <div v-if="row.item.type === 'Rating'">Average rating:
                      <span v-if="row.item.rating_average">{{ row.item.rating_average.toFixed(1) }}</span>
                      <span v-else>-</span>
                    </div>
                    <div v-if="row.item.type === 'Checkbox'">
                      <span v-if="!row.item.checkbox_count">-</span>
                      <div v-for="(c, i) in JSON.parse(row.item.checkbox_count)" :key="'C' + i">
                        {{c.response}}: {{c.count}}
                      </div>
                    </div>
                    <div v-if="row.item.type === 'Dropdown'">
                      <span v-if="!row.item.dropdown_count">-</span>
                      <div v-for="(d, i) in JSON.parse(row.item.dropdown_count)" :key="'D' + i">
                        {{d.response}}: {{d.count}}
                      </div>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <!--        Desktop-->
          <div class="d-sm-block d-none">
            <div v-if="survey_questions.length > 0" class="row table-content">
              <div class="col">
                <b-table hover :items="survey_questions"
                         :fields="['question', 'type', 'response_summary', 'actions']">
                  <template v-slot:cell(question)="row">
                    <span>{{ row.item.question }}</span>
                    <badge class="ml-2" type="danger" v-if="!row.item.active">inactive</badge>
                  </template>
                  <template v-slot:cell(type)="row">
                    <badge>{{ row.item.type }}</badge>
                  </template>
                  <template v-slot:cell(response_summary)="row">
                    <span v-if="row.item.type === 'Input'">Response count: {{ row.item.input_count }}</span>
                    <span v-if="row.item.type === 'Rating'">Average rating:
                      <span v-if="row.item.rating_average">{{ row.item.rating_average.toFixed(1) }}</span>
                      <span v-else>-</span>
                    </span>
                    <span v-if="row.item.type === 'Checkbox'">
                      <span v-if="!row.item.checkbox_count">-</span>
                      <div v-for="(c, i) in getAggregates(row.item.checkbox_count)" :key="'C' + i">
                        {{c.response}}: {{c.count}}
                      </div>
                    </span>
                    <span v-if="row.item.type === 'Dropdown'">
                      <span v-if="!row.item.dropdown_count">-</span>
                      <div v-for="(d, i) in getAggregates(row.item.dropdown_count)" :key="'D' + i">
                        {{d.response}}: {{d.count}}
                      </div>
                    </span>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <el-dropdown>
                      <base-button
                        simple
                        type="primary"
                        link
                      > <i style="font-size: medium" class="tim-icons el-icon-more"></i>
                      </base-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <a class="dropdown-item" href="#" @click="viewQuestionResponses(row.item)">
                            <i class="tim-icons icon-notes mr-2 text-info"></i> View all responses for this question
                          </a>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </b-table>
              </div>
            </div>
          </div>


        </div>

        <div v-if="activeTabIndex === 1">
          <filter-bar
            :filters="filterSchema"
            :initial-value="filterValues"
            :result-count="totalRows"
            :per-page="perPage"
            :per-page-options="perPageOptions"
            saved-filters-key="survey-history"
            :saved-filters-entity="savedViewsEntity"
            @change="onFiltersChanged"
            @update:perPage="onPerPageChange"
          >
            <template #actions>
              <el-popover trigger="click" placement="bottom-end">
                <div>
                  <h3 class="popover-header">Display the following columns</h3>
                  <div class="pop popover-body">
                    <div class="row" v-for="(q, i) in survey_questions" :key="'Q' + i">
                      <div class="col">
                        <base-checkbox v-model="q.selected" v-on:input="updateColumnViews(q)">{{ q.question }}</base-checkbox>
                      </div>
                    </div>
                    <div class="mt-2 text-right">
                      <base-button size="sm" link type="primary" v-on:click="selectAllQuestions()">Select all</base-button>
                      <base-button size="sm" link type="primary" v-on:click="deselectAllQuestions()">Deselect all</base-button>
                    </div>
                  </div>
                </div>
                <base-button slot="reference" icon class="btn-link text-white" title="Columns">
                  <i class="tim-icons icon-bullet-list-67"></i>
                </base-button>
              </el-popover>
              <base-button v-if="hasPermissions('download_data')" icon class="btn-link text-white" v-on:click="downloadCSV()">
                <i class="tim-icons icon-cloud-download-93"></i>
              </base-button>
            </template>
          </filter-bar>
          <div class="mt-3" v-if="survey_history.length <= 0 ">
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No surveys have been filled out yet.</h4>
            </div>
          </div>

          <!--        Mobile-->
          <div class="d-block d-sm-none">
            <div v-if="survey_history.length > 0" class="row table-content">
              <div class="col">
                <b-table hover :items="survey_history"
                         :current-page="currentPage"
                         :fields="['surveys']">
                  <template v-slot:head(surveys)="row">
                    <span>Total results: {{totalRows}}</span>
                  </template>
                  <template v-slot:cell(surveys)="row">
                    <p class="text-primary">{{row.item.name}}</p>
                    <small>{{row.item.description}}</small>
                    <div v-if="!row.item.customer_first_name && !row.item.customer_last_name && !row.item.email && !row.item.customer_phone">
                      <badge>anonymous</badge>
                    </div>
                    <p v-else> Submitted by {{row.item.customer_first_name}} {{row.item.customer_last_name}}
                      <el-tooltip content="View customer"
                                  effect="light"
                                  :open-delay="300"
                                  placement="top">
                        <i v-if="row.item.email" v-on:click="viewCustomer(row.item)"
                           style="cursor: pointer" class="tim-icons el-icon-top-right text-primary"></i>
                      </el-tooltip>
                    </p>
                    <div class="row">
                      <div class="col">
                        <small>
                          <i v-if="row.item.email" class="tim-icons icon-email-85"></i> {{row.item.email}}
                          <i v-if="row.item.customer_phone" class="tim-icons el-icon-mobile-phone"></i> {{row.item.customer_phone}}
                        </small>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <small>Submitted on {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</small>
                      </div>
                    </div>

                    <div class="row mt-2" v-if="row.item.game">
                      <div class="col">
                        <div>
                          {{row.item.game}}
                          <i v-if="row.item.game_instance_id" style="cursor: pointer" v-on:click="viewGameInstance(row.item.game_instance_id)"
                             class="tim-icons el-icon-top-right text-primary"></i>
                        </div>
                        <small v-if="row.item.booking_date && row.item.start_time">
                          <i class="tim-icons icon-calendar-60 mr-1"></i> {{getFormattedDate(row.item.booking_date)}}
                          <i class="tim-icons el-icon-alarm-clock ml-2"></i> {{getTime(row.item.start_time)}}
                        </small>
                      </div>
                    </div>

                    <div class="row mt-2" v-if="row.item.game_master">
                      <div class="col">
                        <span>Game master: {{row.item.game_master}}</span>
                      </div>
                    </div>

                    <div
                      class="btn-group btn-group-toggle mt-3 mb-2"
                      :class="'float-left'"
                      data-toggle="buttons" style="width:100%"
                    >
                      <label class="btn btn-sm btn-primary btn-simple">
                        <base-button
                          @click.native="deleteSurveyResponsePrompt(row.item)"
                          type="primary"
                          class="btn btn-link"
                          size="sm"
                          icon
                        ><i class="tim-icons icon-trash-simple"></i>
                        </base-button>
                      </label>
                      <label class="btn btn-sm btn-primary btn-simple">
                        <base-button
                          @click.native="viewSurveyResponse(row.item)"
                          type="primary"
                          class="btn btn-link"
                          size="sm"
                          icon
                        ><i class="tim-icons icon-notes"></i>
                        </base-button>
                      </label>
                    </div>
                  </template>
                </b-table>
                <b-pagination v-on:input="getSurveyHistory(perPage, getOffset())"
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                ></b-pagination>
              </div>
            </div>
          </div>

          <!--        Desktop-->
          <div class="d-sm-block d-none">
            <div v-if="survey_history.length > 0" class="row table-content">
              <div class="col">
                <b-table hover :items="survey_history"
                         :current-page="currentPage"
                         :fields="surveyResponderFields">
                  <template v-slot:cell()="row">
                    <span>{{ getAnswer(JSON.parse(row.item.questions), row.field.key) }}</span>
                  </template>
                  <template v-slot:cell(submitted_by)="row">
                    <div v-if="!row.item.customer_first_name && !row.item.customer_last_name && !row.item.email && !row.item.customer_phone">
                      <badge>anonymous</badge>
                    </div>
                    <p>{{row.item.customer_first_name}} {{row.item.customer_last_name}}
                      <el-tooltip content="View customer"
                                  effect="light"
                                  :open-delay="300"
                                  placement="top">
                        <i v-if="row.item.email" v-on:click="viewCustomer(row.item)"
                           style="cursor: pointer" class="tim-icons el-icon-top-right text-primary"></i>
                      </el-tooltip>
                    </p>
                    <small>
                      <i v-if="row.item.email" class="tim-icons icon-email-85"></i> {{row.item.email}}
                      <i v-if="row.item.customer_phone" class="tim-icons el-icon-mobile-phone"></i> {{row.item.customer_phone}}
                    </small>
                  </template>
                  <template v-slot:cell(game)="row">
                    <span v-if="!row.item.game">-</span>
                    <div v-if="row.item.game">
                     {{row.item.game}}
                        <i v-if="row.item.game_instance_id" style="cursor: pointer" v-on:click="viewGameInstance(row.item.game_instance_id)"
                           class="tim-icons el-icon-top-right text-primary"></i>
                    </div>
                    <div v-if="row.item.booking_date && row.item.start_time">
                      <i class="tim-icons icon-calendar-60 mr-1"></i> {{getFormattedDate(row.item.booking_date)}}
                      <i class="tim-icons el-icon-alarm-clock ml-2"></i> {{getTime(row.item.start_time)}}
                    </div>
                  </template>
                  <template v-slot:cell(game_master)="row">
                    <span v-if="!row.item.game_master">-</span>
                    <span v-else>{{row.item.game_master}}</span>
                  </template>
                  <template v-slot:cell(time_submitted)="row">
                    <span>{{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</span>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <el-dropdown>
                      <base-button
                        simple
                        type="primary"
                        link
                      > <i style="font-size: medium" class="tim-icons el-icon-more"></i>
                      </base-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <a class="dropdown-item mb-2" href="#" @click="viewSurveyResponse(row.item)">
                            <i class="tim-icons icon-notes mr-2 text-info"></i> View customer's survey
                          </a>
                          <hr>
                          <a class="dropdown-item mb-2" @click="deleteSurveyResponsePrompt(row.item)" href="#">
                            <i class="tim-icons icon-trash-simple text-danger mr-2"></i> Delete this survey
                          </a>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </b-table>
                <b-pagination v-on:input="getSurveyHistory(perPage, getOffset())"
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</div>
</template>

<script>
import {Auth} from "aws-amplify";
import {API_LOCATION} from "@/api-config";
import _ from "lodash";
import swal from "sweetalert2";
import {BTable, BPagination, BRow, BCol} from "bootstrap-vue";
import {dayOfWeek, formattedDate, time} from "@/plugins/dateFormatter";
import {formatGroupDate, formatGroupTime} from "@/plugins/dates";
import axios from "axios";
import Badge from "@/components/Badge";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import BreadcrumbItem from "@/components/Breadcrumb/BreadcrumbItem";
import {Dropdown, DropdownItem, DropdownMenu} from "element-ui";

export default {
  name: "SurveyHistory",
  components: {
    BTable,
    BPagination,
    Badge,
    Breadcrumb, BreadcrumbItem,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    BRow,
    BCol
  },
  data(){
    return {
      loading: false,
      survey_history: [],
      survey_questions: [],
      survey: '',
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      perPageOptions: [5, 10, 25, 50],
      time_format: JSON.parse(localStorage.getItem('group')).time_format,
      date_format: JSON.parse(localStorage.getItem('group')).date_format,
      activeTabIndex: 0,
      j: 0,
      surveyResponderFields: ['submitted_by', 'game', 'game_master', 'time_submitted', 'actions'],
      games: [],
      // SavedViewsMenu/FilterBar drives the first fetch via its initial @change; this guards it.
      didInitialFetch: false,
      // Flat filter values for the shared <filter-bar>. Seeded from the URL;
      // saved-views precedence is resolved by FilterBar. game = array of game ids.
      filterValues: {
        customer: '',
        game: [],
        game_master: '',
        submitted: { mode: 'range', days: '', from: '', to: '' }
      }
    }
  },
  computed: {
    // The survey these saved views belong to; FilterBar stores it in the saved
    // blob so the saved views drawer can open this survey's results.
    savedViewsEntity() {
      return { id: this.$route.query.id, name: this.survey && this.survey.name ? this.survey.name : undefined }
    },
    categories() {
      return [{ name: 'All questions', icon: 'tim-icons icon-notes', active: true },
        { name: 'Responders', icon: 'tim-icons icon-chart-bar-32', active: false }
      ];
    },
    // Schema for the shared <filter-bar>: customer/game master text, multi-select game, submitted daterange.
    filterSchema() {
      return [
        { key: 'customer', type: 'text', label: 'Customer', placeholder: 'Customer name or email', operatorLabel: 'contains', primary: true },
        { key: 'game', type: 'multiselect', label: 'Game', primary: true,
          options: (Array.isArray(this.games) ? this.games : []).map(g => ({ label: g.name, value: g.id })) },
        { key: 'game_master', type: 'text', label: 'Game master', placeholder: 'Game master name', operatorLabel: 'contains', primary: true },
        { key: 'submitted', type: 'daterange', label: 'Time submitted', primary: true }
      ]
    },
  },
  methods: {
    hasPermissions(scope){
      let permissions = JSON.parse(localStorage.getItem('permissions'))
      const matchFound = permissions.some(element => element === scope);
      return matchFound
    },
    // FilterBar change: apply new values and (re)fetch. The first change is
    // FilterBar's initial saved-views resolution and drives the first load.
    onFiltersChanged(values){
      const s = values.submitted || {}
      this.filterValues = {
        customer: values.customer || '',
        game: Array.isArray(values.game) ? values.game : [],
        game_master: values.game_master || '',
        submitted: {
          mode: s.mode || 'range',
          days: s.days || '',
          from: s.from || '',
          to: s.to || ''
        }
      }
      if(!this.didInitialFetch){
        this.didInitialFetch = true
        this.getSurveyHistory(this.perPage, this.getOffset())
      } else {
        // Applying a filter/view lands on page 1; reset before computing the offset.
        this.currentPage = 1
        this.getSurveyHistory(this.perPage, this.getOffset())
      }
    },
    onPerPageChange(n){
      this.perPage = n
      this.currentPage = 1
      this.getSurveyHistory(this.perPage, this.getOffset())
    },
    async getGames () {
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/games'
      this.axios.get(url, config)
        .then(response => {
          this.games = response.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            swal({
              title: 'Error',
              html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else if(err.response.status == 500){
            swal({
              title: 'Error',
              html: 'The feature has not been enabled as part of your subscription plan.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    getAnswer(responses, question){
      let response = _.find(responses, { question: question})
      if(response){
        if(response.type === 1){
          if(response.response && JSON.parse(response.response).length > 0){

            return JSON.parse(response.response).join(', ')
          }
          return '-'
        }
        if (
          typeof response.response === 'string' &&
          response.response.trim().startsWith('[') &&
          response.response.trim().endsWith(']')
        ) {
          try {
            const parsed = JSON.parse(response.response);
            if (Array.isArray(parsed) && parsed.length > 0) {
              return parsed.join(', ');
            }
          } catch (e) {
            console.warn('Failed to parse response:', e);
          }
        }

        if(response.response === '[]'){
          return '-'
        }

        return response.response
      }
      return '-'
    },
    getColumnPrefsKey() {
      const surveyId = this.$route.query.id
      return `surveyQuestionColumns_${surveyId}`
    },
    saveColumnPreferences() {
      const selectedQuestions = this.survey_questions
        .filter(q => q.selected)
        .map(q => q.id)
      localStorage.setItem(this.getColumnPrefsKey(), JSON.stringify(selectedQuestions))
    },
    loadColumnPreferences() {
      const saved = localStorage.getItem(this.getColumnPrefsKey())
      if (saved) {
        try {
          const selectedIds = JSON.parse(saved)
          // Apply saved selection state to questions
          this.survey_questions.forEach(q => {
            q.selected = selectedIds.includes(q.id)
          })
          // Rebuild surveyResponderFields from saved selection
          this.rebuildColumnFields()
        } catch (e) {
          console.error('Failed to load column preferences', e)
          this.selectAllQuestions()
        }
      } else {
        // No saved preferences - select all by default
        this.selectAllQuestions()
      }
    },
    selectAllQuestions() {
      this.survey_questions.forEach(q => {
        q.selected = true
      })
      this.rebuildColumnFields()
      this.saveColumnPreferences()
    },
    deselectAllQuestions() {
      this.survey_questions.forEach(q => {
        q.selected = false
      })
      this.surveyResponderFields = ['submitted_by', 'game', 'game_master', 'time_submitted', 'actions']
      this.saveColumnPreferences()
    },
    rebuildColumnFields() {
      const baseFields = ['submitted_by', 'game', 'game_master', 'time_submitted']
      const selectedQuestionNames = this.survey_questions
        .filter(q => q.selected)
        .map(q => q.question)
      this.surveyResponderFields = [...baseFields, ...selectedQuestionNames, 'actions']
    },
    updateColumnViews(question){
      if(question.selected){
        let insertPosition = this.surveyResponderFields.length - 1;
        this.surveyResponderFields.splice(insertPosition, 0, question.question);
      } else {
        this.surveyResponderFields = this.surveyResponderFields.filter(item => item !== question.question);
      }
      this.saveColumnPreferences()
    },
    viewGameInstance(id){
      this.$router.push({ path: '/games/history/instance', query: { id: id }})
    },
    getAggregates(item){
      return _.orderBy(JSON.parse(item), 'count', 'desc')
    },
    switchTab(index){
      this.activeTabIndex = index
      for(let n in this.categories){
        this.categories[n].active = false
      }
      this.categories[index].active = true
      this.j++
    },
    viewCustomer(user){
      this.$router.push({ path: '/customers/details', query: { id:  user.end_user_id }})
    },
    async getAllSurveyQuestions(config, count){
      let url = ''
      let promises = []
      let csvData = []
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let offset = 0
      let surveyId = this.$route.query.id
      while(offset <= this.totalRows){

        url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/surveys/' + surveyId + '/questions?count=' + count + "&offset=" + offset
        promises.push(
          axios.get(url, config)
            .then(response =>{
              csvData.push(response.data.survey_history)
            })
            .catch(err => {
              console.log(err)
              if(err.response.status == 401){
                swal({
                  title: 'Error',
                  html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
                  type: 'error',
                }).then((response)=> {
                  this.$router.push('/')
                })
              }
              else if(err.response.status == 500){
                swal({
                  title: 'Error',
                  html: 'The feature has not been enabled as part of your subscription plan.',
                  type: 'error',
                }).then((response)=> {
                  this.$router.push('/')
                })
              }
              else {
                swal('Error!', 'Something went wrong', 'error')
              }

            })
        )
        offset = offset + count
      }

      await Promise.all(promises)

      // merge all response arrays into one
      let arr = []
      csvData.forEach((element) => {
        arr = arr.concat(element)

      })
      return arr
    },
    async getAllSurveys(config, count){
      let url = ''
      let promises = []
      let csvData = []
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let offset = 0
      let surveyId = this.$route.query.id

      let game_id = (this.filterValues.game || []).join(',')
      const { to, from } = this.getSubmittedRange()
      while(offset <= this.totalRows){

        url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/surveys/' + surveyId + '/responders?count='
          + count + "&offset=" + offset + '&customer=' + encodeURIComponent(this.filterValues.customer)
          + '&game_master=' + encodeURIComponent(this.filterValues.game_master)
          + '&game=' + game_id + "&to=" + to + "&from=" + from
        promises.push(
          axios.get(url, config)
            .then(response =>{
              csvData.push(response.data.survey_history)
            })
            .catch(err => {
              console.log(err)
              if(err.response.status == 401){
                swal({
                  title: 'Error',
                  html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
                  type: 'error',
                }).then((response)=> {
                  this.$router.push('/')
                })
              }
              else if(err.response.status == 500){
                swal({
                  title: 'Error',
                  html: 'The feature has not been enabled as part of your subscription plan.',
                  type: 'error',
                }).then((response)=> {
                  this.$router.push('/')
                })
              }
              else {
                swal('Error!', 'Something went wrong', 'error')
              }
            })
        )
        offset = offset + count
      }

      await Promise.all(promises)

      // merge all response arrays into one
      let arr = []
      csvData.forEach((element) => {
        arr = arr.concat(element)

      })
      return arr
    },
    escapeCSVValue(value) {
      if(value === null || value === ''){
        return '-'
      }
      if (typeof value === 'string') {
        // Escape double quotes by doubling them
        value = value.replace(/"/g, '""');

        // If the value contains a comma, wrap it in double quotes
        if (value.includes(',') || value.includes('\n')) {
          value = `"${value}"`;
        }
      }
      return value;
    },
    async downloadCSV(){
      //get the entire data set
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }

      this.loading = true
      let count = 5000
      let csvData = await this.getAllSurveys(config, count)
      this.loading = false

      let baseHeader = 'Customer First Name,Customer Last Name,Customer Email,' +
        'Customer Phone,Date Submitted,Game,Booking Date,Game Master\n';

      const middleFields = this.surveyResponderFields.slice(4, this.surveyResponderFields.length - 1).map(field => {
        let withSpaces = field.replace(/_/g, ' ');
        withSpaces = withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
        const escaped = withSpaces.replace(/"/g, '""');
        return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped;
      });

      let csv = baseHeader.trimEnd() + (middleFields.length ? ',' + middleFields.join(',') : '') + '\n';

      const middleHeaders = this.surveyResponderFields.slice(4, -1);
      csvData.forEach(row => {
        let q = [];
        try {
          const parsed = JSON.parse(row.questions);
          if (Array.isArray(parsed)) {
            q = parsed;
          }
        } catch (err) {
          console.warn('Failed to parse questions:', row.questions, err);
        }

        // ✅ Define the map BEFORE using it
        const questionMap = {};
        q.forEach(entry => {
          if (entry && entry.question) {
            questionMap[entry.question.trim()] = entry.response || '';
          }
        });

        const baseCols = [
          this.escapeCSVValue(row.customer_first_name),
          this.escapeCSVValue(row.customer_last_name),
          this.escapeCSVValue(row.email),
          this.escapeCSVValue(row.customer_phone),
          JSON.stringify(this.getLocalDate(row.timestamp) + ' ' + this.getLocalTime(row.timestamp)),
          this.escapeCSVValue(row.game),
          this.escapeCSVValue(this.getFormattedDate(row.booking_date)),
          this.escapeCSVValue(row.game_master)
        ];

        // For each middle header, pull the matching response from the questionMap
        const dynamicCols = middleHeaders.map(qText => {
          let response = questionMap[qText.trim()] || '';
          if (
            typeof response === 'string' &&
            response.trim().startsWith('[') &&
            response.trim().endsWith(']')
          ) {
            try {
              const parsed = JSON.parse(response);
              if (Array.isArray(parsed) && parsed.length > 0) {
                response = parsed.join(', ');
              }
            } catch (e) {
              console.warn('Failed to parse response:', e);
            }
          }
          if(response === '[]'){
            response = '-'
          }
          return this.escapeCSVValue(response);
        });

        csv += baseCols.concat(dynamicCols).join(',') + "\n";
      });

      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = this.survey.name + '.csv';
      anchor.click();
    },
    // Translate the FilterBar daterange ({ mode, days, from, to }) into the
    // backend's ISO to/from window. Empty strings mean "no date filter".
    getSubmittedRange(){
      const s = this.filterValues.submitted || {}
      let to = ''
      let from = ''
      if (s.mode === 'days' && s.days !== '' && s.days != null){
        let today = new Date()
        let dt = new Date()
        dt.setDate(dt.getDate() - Number(s.days))
        let userStartDate = dt.getFullYear() + "-" + ('0' + (dt.getMonth() + 1)).slice(-2) + "-" + ('0' + dt.getDate()).slice(-2)
        let userEndDate = today.getFullYear() + "-" + ('0' + (today.getMonth() + 1)).slice(-2) + "-" + ('0' + today.getDate()).slice(-2)
        from = new Date(`${userStartDate}T00:00:00`).toISOString()
        to = new Date(`${userEndDate}T23:59:59`).toISOString()
      }
      if (s.mode === 'range' && s.from !== '' && s.to !== ''){
        from = new Date(`${s.from}T00:00:00`).toISOString()
        to = new Date(`${s.to}T23:59:59`).toISOString()
      }
      return { to, from }
    },
    addQueryParameters() {
      const s = this.filterValues.submitted || {}
      const newQuery = {
        ...this.$route.query,
        count: this.perPage,
        page: this.currentPage,
        customer: this.filterValues.customer,
        game: (this.filterValues.game || []).join(','),
        game_master: this.filterValues.game_master,
        submitted_mode: s.mode || '',
        submitted_days: s.days || '',
        submitted_from: s.from || '',
        submitted_to: s.to || '',
      }
      this.$router.replace({query: newQuery}).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    viewQuestionResponses(item){
      this.$router.push({ path: '/surveys/history/question', query: { id:  item.survey_id, question_id: item.id }})
    },
    viewSurveyResponse(item){
      this.$router.push({ path: '/surveys/history/response', query: { id:  item.id }})
    },
    deleteSurveyResponsePrompt(item){
      swal({
        title: 'Are you sure?',
        text: 'This will permanently delete the survey response.',
        type: 'warning',
        showCancelButton: true,
      }).then((response)=> {
        if(response.value == true){
          this.deleteSurveyResponse(item)
        }
      })
    },
    async deleteSurveyResponse(item){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/surveys/history/' + item.id

      this.loading = true
      this.axios.delete(url, config)
        .then(response => {
          swal('Success!', 'Survey response has been deleted.', 'success')
         this.getSurveyHistory(this.perPage, this.getOffset())
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            swal({
              title: 'Error',
              html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else if(err.response.status == 500){
            swal({
              title: 'Error',
              html: 'The feature has not been enabled as part of your subscription plan.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    getLocalTime(d){
      return formatGroupTime(d)
    },
    getLocalDate(d){
      return formatGroupDate(d)
    },
    getTime(d) {
      return time(this.time_format, d)
    },
    getDayOfWeek(d){
      if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
        return dayOfWeek(d) + ', '
      }
      return ''
    },
    getFormattedDate(d){
      if(d instanceof Date){
        d = d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate()
      }
      return formattedDate(this.date_format, d)
    },
    getAuthToken() {
      return new Promise(function (resolve) {
        Auth.currentSession()
          .then(data => {
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    async getSurveyHistory(count, offset){

      // FilterBar flat values: customer/game master text, game id array, submitted daterange.
      let game_id = (this.filterValues.game || []).join(',')
      const { to, from } = this.getSubmittedRange()

      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let surveyId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/surveys/' + surveyId + '/responders?count=' + count +
      '&offset=' + offset + '&customer=' + encodeURIComponent(this.filterValues.customer)
        + '&game_master=' + encodeURIComponent(this.filterValues.game_master)
       + '&game=' + game_id + "&to=" + to + "&from=" + from

      this.axios.get(url, config)
        .then(response => {
          this.loading = false
          this.survey_history = response.data.survey_history
          this.survey = response.data.survey
          this.totalRows = response.data.total_rows
          this.addQueryParameters()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            swal({
              title: 'Error',
              html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else if(err.response.status == 500){
            swal({
              title: 'Error',
              html: 'The feature has not been enabled as part of your subscription plan.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    async getSurveyQuestions(){

      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let surveyId = this.$route.query.id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/surveys/' + surveyId + '/questions'

      this.loading = true
      this.axios.get(url, config)
        .then(response => {
          this.survey_questions = response.data.survey_history
          this.survey = response.data.survey
          this.loading = false
          // Apply saved column preferences (or default to all selected)
          this.loadColumnPreferences()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            swal({
              title: 'Error',
              html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else if(err.response.status == 500){
            swal({
              title: 'Error',
              html: 'The feature has not been enabled as part of your subscription plan.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })
    },
    getOffset(){
      return parseInt((this.currentPage * this.perPage) - this.perPage)
    },
  },
  mounted() {
    this.getGames()
    this.getSurveyQuestions()
    // Default when the query omits count/page, otherwise Number(undefined) => NaN builds a bad fetch URL.
    this.perPage = Number(this.$route.query.count) || 10
    this.currentPage = Number(this.$route.query.page) || 1
    this.loading = true
    // Seed FilterBar's flat values from the URL. FilterBar resolves saved-views
    // precedence and drives the first fetch via its initial `change` (onFiltersChanged).
    const q = this.$route.query || {}
    this.filterValues = {
      customer: q.customer || '',
      game: q.game ? String(q.game).split(',').filter(v => v !== '').map(Number) : [],
      game_master: q.game_master || '',
      submitted: {
        mode: q.submitted_mode || 'range',
        days: q.submitted_days || '',
        from: q.submitted_from || '',
        to: q.submitted_to || ''
      }
    }
  }
}
</script>

<style scoped>

</style>
